import styled, { css, createGlobalStyle } from 'styled-components'
import { Menu } from 'antd'

export const LogoWrapper = styled.div`
  display: flex;
  flex-grow: 1;
  a {
    display: flex;
    align-items: center;
    padding-left: 15px;
  }
  h1 {
    font-size: 16px;
    padding: 0 15px;
    margin-bottom: 0;
    color: rgba(0, 0, 0);
    display: flex;
    align-items: center;
  }
  .eoffice-menu {
    margin: 0 15px 0 auto;
    display: flex;
    .ant-menu-item,
    .ant-menu-submenu {
      display: flex;
      align-items: center;
      cursor: pointer;
      border-top: 2px solid transparent;
      &.ant-menu-item-selected,
      &:hover,
      &.active-category {
        border-bottom: 2px solid transparent;
        border-top: 2px solid ${props => props.theme.solidColor};
        color: ${props => props.theme.solidColor};
      }
    }
  }
`
export const AvatarWrapper = styled.div`
  overflow: hidden;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  margin-right: 10px;
  display: inline-block;
  img {
    width: 100%;
    height: 100%;
    display: block;
    object-fit: cover;
    object-position: center;
  }
`
export const MenuWrapper = styled.div`
  display: flex;
  align-items: center;
`
export const UserMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  padding: 15px;
`
export const NotificationMenu = styled.a`
  display: flex;
  align-items: center;
  margin-right: ${props => (props.hasNotification !== 0 ? '22px' : '10px')};
  &:hover {
    cursor: pointer;
  }
  .anticon {
    font-size: 24px;
    color: rgba(0, 0, 0);
  }
`
export const SettingMenu = styled.a`
  display: flex;
  align-items: center;
  .anticon {
    font-size: 22px;
    color: rgba(0, 0, 0);
  }
`
export const DropdownMenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 5px 12px;
  .title {
    font-weight: 600;
    margin-right: 100px;
  }
`
export const NotificationItem = styled.a`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  p {
    margin-bottom: 0;
    margin-top: 3px;
    width: 100%;
    padding-right: 100px;
    white-space: nowrap;
    overflow: hidden;
    color: rgba(0, 0, 0);
    text-overflow: ellipsis;
    font-weight: ${props => (props.isRead ? 'normal' : 800)};
  }
  small,
  time {
    color: #919699;
    font-size: 12px;
  }
  .ant-tag {
    border-radius: 0 !important;
    padding: 0 5px !important;
    min-width: unset !important;
  }
`
export const UserMenu = styled.a`
  display: flex;
  align-items: center;
  color: rgba(0, 0, 0);
  margin-left: 18px;
  font-size: 14px;
  &:hover {
    color: rgba(0, 0, 0);
  }
`

export const ThemeChanger = styled.ul`
  display: flex;
  align-items: center;
`
export const ThemeItem = styled.li`
  display: block;
  width: 20px;
  height: 20px;
  margin-right: 5px;
  border-radius: 2px;
  background: ${props => props.theme};
  padding: 0 !important;
  position: relative;
  &:hover {
    cursor: pointer;
  }
  ${props =>
    props.isCurrent &&
    css`
      &:before {
        display: block;
        content: '';
        width: 6px;
        height: 10px;
        border-right: 2px solid white;
        border-bottom: 2px solid white;
        position: absolute;
        top: 50%;
        left: 50%;
        transform: translate(-50%, -50%) rotate(45deg);
      }
    `}
`
export const TaskSearchBarWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-grow: 1;
  justify-content: flex-start;
  padding-right: 30px;
  padding-left: 15px;
  position: relative;
  .ant-input-search {
    max-width: 300px;
    height: 38px;
    border-top-right-radius: 0;
    border-bottom-right-radius: 0;
    position: relative;
    z-index: 1;
  }
  .filter-button {
    border: 1px solid #d9d9d9;
    color: rgba(0, 0, 0);
    height: 38px;
    padding: 0 5px;
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
    margin-left: -1px;
    &:hover,
    &:focus,
    &:focus-within {
      position: relative;
      z-index: 1;
    }
  }
`

export const HeaderBarWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  width: 100%;
  min-width: 0;

  @media (max-width: 640px) {
    align-items: flex-start;
    flex-direction: column;
    gap: 12px;
  }
`

export const HeaderBreadcrumbArea = styled.div`
  display: flex;
  align-items: center;
  min-width: 0;
  margin-right: auto;
  font-family: 'Inter', Noto Sans Display, sans-serif !important;

  .app-breadcrumb {
    display: inline-flex !important;
    align-items: center !important;
    min-width: 0 !important;
    font-family: 'Inter', Noto Sans Display, sans-serif !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    height: 17px !important;
    line-height: 17px !important;
    color: #5b6b79 !important;

    > span {
      display: inline-flex !important;
      align-items: center !important;
      vertical-align: middle !important;
      height: 17px !important;
      line-height: 17px !important;
    }

    .ant-breadcrumb-link {
      display: inline-flex !important;
      align-items: center !important;
      vertical-align: middle !important;
      font-size: 14px !important;
      height: 17px !important;
      line-height: 17px !important;
      color: #5b6b79 !important;
    }

    .ant-breadcrumb-separator {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      vertical-align: middle !important;
      margin: 0 8px !important;
      height: 17px !important;
      line-height: 17px !important;
    }

    .breadcrumb-separator {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      color: #5b6b79 !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      height: 17px !important;
      line-height: 17px !important;
      user-select: none;
    }

    a {
      display: inline-flex !important;
      align-items: center !important;
      font-size: 14px !important;
      font-weight: 400 !important;
      height: 17px !important;
      line-height: 17px !important;
      color: #1d2630 !important;
      text-decoration: none !important;
      transition: color 0.2s ease;

      &:hover {
        color: #1d2630 !important;
      }
    }

    > span:last-child {
      color: #1d2630 !important;
      height: 17px !important;
      line-height: 17px !important;

      a,
      .ant-breadcrumb-link {
        color: #1d2630 !important;
        font-size: 14px !important;
        font-weight: 400 !important;
        height: 17px !important;
        line-height: 17px !important;
      }

      .ant-breadcrumb-separator,
      .breadcrumb-separator {
        display: none !important;
      }
    }

    .breadcrumb-home-icon {
      display: inline-flex !important;
      align-items: center !important;
      justify-content: center !important;
      height: 17px !important;
      line-height: 17px !important;

      a {
        display: inline-flex !important;
        align-items: center !important;
        justify-content: center !important;
        height: 17px !important;
        color: #5b6b79 !important;
      }
    }

    .breadcrumb-home-svg {
      display: block !important;
      width: 17px !important;
      height: 17px !important;
      color: #5b6b79 !important;
    }
  }
`

export const HeaderActions = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 14px;
  min-width: 0;

  @media (max-width: 900px) {
    gap: 10px;
  }

  @media (max-width: 640px) {
    width: 100%;
    justify-content: flex-end;
  }
`

export const HeaderAlertWrapper = styled.div`
  flex: 0 1 auto;

  .ant-alert {
    border-radius: 8px;
    margin-right: 0;
  }
`

export const HeaderGuideLink = styled.a`
  color: #2c65ac;
  font-size: 14px;
  font-weight: 600;
  text-decoration: underline;
  white-space: nowrap;

  &:hover {
    color: #043871;
    text-decoration: underline;
  }

  @media (max-width: 900px) {
    display: none;
  }
`

export const HeaderNotificationTrigger = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;

  .header-notification-icon {
    width: 20px;
    height: 20px;
    color: #111827;
  }
`

export const HeaderAccountTrigger = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 12px;
  min-width: 0;
  cursor: pointer;
  border-radius: 12px;
  padding: 6px 8px;
  outline: none;
  transition: background 0.2s ease;

  &:hover,
  &:focus {
    background: #f8fafc;
  }

  .header-avatar {
    flex-shrink: 0;
    background: #e9f2ff;
    color: #2c65ac;
    font-weight: 700;
  }

  .header-account-chevron {
    width: 20px;
    height: 20px;
    flex-shrink: 0;
    color: #111827;
  }
`

export const HeaderAccountInfo = styled.div`
  min-width: 0;

  @media (max-width: 900px) {
    display: none;
  }
`

export const HeaderAccountName = styled.div`
  max-width: 160px;
  overflow: hidden;
  color: #181616;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const HeaderAccountRole = styled.div`
  max-width: 160px;
  overflow: hidden;
  color: #98a2b3;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  text-overflow: ellipsis;
  white-space: nowrap;
`

export const StyledUserMenu = styled(Menu)`
  padding: 4px !important;
  border-radius: 10px !important;
  min-width: 148px !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08) !important;
  border: 1px solid #f0f2f5 !important;
  background: #ffffff !important;

  .ant-menu-item,
  .ant-dropdown-menu-item {
    display: flex !important;
    align-items: center !important;
    height: 32px !important;
    line-height: 32px !important;
    padding: 0 10px !important;
    border-radius: 6px !important;
    font-size: 13px !important;
    font-weight: 500 !important;
    margin: 1px 0 !important;
    transition: background-color 0.15s ease, color 0.15s ease !important;

    .ant-menu-item-icon,
    .ant-dropdown-menu-item-icon,
    .anticon {
      font-size: 14px !important;
      margin-right: 8px !important;
    }

    &.menu-profile {
      color: #1e293b !important;

      .ant-menu-item-icon,
      .ant-dropdown-menu-item-icon,
      .anticon {
        color: #003a70 !important;
      }

      &:hover,
      &.ant-menu-item-active,
      &.ant-dropdown-menu-item-active {
        background-color: #f1f5f9 !important;
        color: #003a70 !important;
        border-radius: 6px !important;
      }
    }

    &.menu-logout,
    &.ant-menu-item-danger,
    &.ant-dropdown-menu-item-danger {
      color: #ff4d4f !important;

      .ant-menu-item-icon,
      .ant-dropdown-menu-item-icon,
      .anticon {
        color: #ff4d4f !important;
      }

      &:hover,
      &.ant-menu-item-active,
      &.ant-dropdown-menu-item-active {
        background-color: #ff4d4f !important;
        color: #ffffff !important;
        border-radius: 6px !important;

        .ant-menu-item-icon,
        .ant-dropdown-menu-item-icon,
        .anticon {
          color: #ffffff !important;
        }
      }
    }
  }

  .ant-menu-item-divider,
  .ant-dropdown-menu-item-divider {
    margin: 3px 4px !important;
    background-color: #f1f5f9 !important;
  }
`

export const HeaderUserDropdownGlobalStyle = createGlobalStyle`
  .header-user-dropdown {
    .ant-dropdown-menu {
      min-width: 148px !important;
      padding: 4px !important;
      border-radius: 10px !important;
      box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08) !important;
      border: 1px solid #f0f2f5 !important;
      background: #ffffff !important;
    }

    .ant-dropdown-menu-item {
      display: flex !important;
      align-items: center !important;
      height: 32px !important;
      line-height: 32px !important;
      padding: 0 10px !important;
      border-radius: 6px !important;
      font-size: 13px !important;
      font-weight: 500 !important;
      margin: 1px 0 !important;
      transition: background-color 0.15s ease, color 0.15s ease !important;

      .ant-dropdown-menu-item-icon,
      .anticon {
        font-size: 14px !important;
        margin-right: 8px !important;
      }

      &.menu-profile {
        color: #1e293b !important;

        .ant-dropdown-menu-item-icon,
        .anticon {
          color: #003a70 !important;
        }

        &:hover,
        &.ant-dropdown-menu-item-active {
          background-color: #f1f5f9 !important;
          color: #003a70 !important;
          border-radius: 6px !important;
        }
      }

      &.menu-logout,
      &.ant-dropdown-menu-item-danger {
        color: #ff4d4f !important;

        .ant-dropdown-menu-item-icon,
        .anticon {
          color: #ff4d4f !important;
        }

        &:hover,
        &.ant-dropdown-menu-item-active {
          background-color: #ff4d4f !important;
          color: #ffffff !important;
          border-radius: 6px !important;

          .ant-dropdown-menu-item-icon,
          .anticon {
            color: #ffffff !important;
          }
        }
      }
    }

    .ant-dropdown-menu-item-divider {
      margin: 3px 4px !important;
      background-color: #f1f5f9 !important;
    }
  }
`
